<!--
 * @Author: your name
 * @Date: 2020-12-11 09:39:11
 * @LastEditTime: 2021-07-07 09:44:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\train\components\apply.vue
-->
<template>
  <div class="apply-wapper">
    <h1>报名 <i class="el-icon-close" @click="handShow"></i></h1>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="报名方向" prop="certname">
        <el-input v-model="certname"></el-input>
      </el-form-item>
      <el-form-item label="输入姓名" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="输入手机号" prop="phone">
        <el-input v-model="ruleForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="所在城市" prop="address">
        <el-cascader 
        :options="catAddress" 
        placeholder="请选择地区"
        ref="refSubCat"
        @change="handleCatName"
        v-model="ruleForm.address"></el-cascader>
      </el-form-item>
          <p class="reveal">提交信息后，将有当地工作人员与您联系，协助报考。</p>
          <el-button type="primary" @click="submitInfo">提交</el-button>
    </el-form>
  </div>
</template>

<script>
import {getcourseApplyApi,getareaApi} from './../../../api/api'
export default {
    props: ['type','certname'], //type 2线上报名 1线下   
    data(){
        return {
            ruleForm: {
                name: '',
                phone: '',
                address: '',
            },
             rules: {
                  name: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur',  },
                    {min:11, max:11, message:'请输入正确的手机号',trigger: 'blur',}
                ],
                address: [
                    {required: true, message: '请输入城市', trigger: 'blur' }
                ]
             },
             catAddress:[],
             city:''
        }
    },
    created(){
        this.getAreaList()
    },
    methods:{
       handleCatName(){
           let address = this.$refs['refSubCat'].getCheckedNodes()[0].pathLabels
           this.city = address[0] + '/' + address[1]
       },
       //提交报名信息
        submitInfo(){
            const params = {
                cert_name:this.certname,
                name: this.ruleForm.name,
                phone: this.ruleForm.phone,
                address: this.city,
                type:this.type
            }
            getcourseApplyApi(params).then(res => {
                if(res.data.code == 1){
                    this.$message.success({
                        message : res.data.msg,
                        duration: 1500,
                        onClose:()=> {
                            this.$emit('showApply', false)
                        }
                    })
                }else{
                    this.$message.warning(res.data.msg)
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        //获取省、市
        getAreaList(){
            getareaApi().then(res => {
                if(res.data.code == 0){
                    this.catAddress = res.data.data
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        handShow(){
            this.$emit('showApply', false)
        }
    }
}
</script>

<style scoped lang="scss">
.apply-wapper {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 999;
    margin-left: -370px;
    margin-top: -262px;
    background-color: #fff;
    width: 740px;
    height: 524px;
    border-radius: 16px;
    h1 {
        height: 54px;
        line-height: 54px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 50px;
        background-color: #f5f5f5;
        padding: 0 15px;
        .el-icon-close {
            float: right;
            font-size: 22px;
            margin-top: 16px;
        }
    }
    >>> .el-input__inner {
        width: 217px;
    }
    >>> .demo-ruleForm{
        padding-left: 210px;
    }
    >>> .el-form-item__label {
        text-align: left;
    }
    .reveal {
        width: 320px;
        color: #999;
        line-height: 24px;
        margin:35px 0 25px ;
    }
   .el-button {
    width: 320px;
    height: 56px;
    background: #4165FF;
    box-shadow: 0px 14px 24px 0px rgba(65, 101, 255, 0.32);
    border-radius: 28px;
  } 
}

</style>



// WEBPACK FOOTER //
// src/components/train/components/apply.vue